import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function AvisoLegal() {
  return (
    <LegalLayout eyebrow="Legal" title="Aviso legal" updated="septiembre de 2026" testid="legal-page-aviso">
      <LegalSection title="1. Titular del sitio web">
        <p>
          En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
          Información y de Comercio Electrónico (LSSI-CE), se informa de que el titular de este sitio web es:
        </p>
        <p>
          <strong className="font-semibold text-slate-900">PisoScore Technologies S.L.</strong>
          <br />
          CIF: [CIF pendiente de asignar]
          <br />
          Domicilio social: [Domicilio social], Madrid, España
          <br />
          Correo electrónico de contacto:{" "}
          <a href="mailto:hola@pisoscore.es" className="font-medium text-emerald-600 hover:text-emerald-700">
            hola@pisoscore.es
          </a>
        </p>
      </LegalSection>

      <LegalSection title="2. Objeto y ámbito de aplicación">
        <p>
          El presente aviso legal regula el acceso, navegación y uso del sitio web de PisoScore (en adelante, «el
          Sitio Web»), una herramienta de tecnología financiera que permite estimar la rentabilidad, el cash flow y
          el retorno potencial de inversiones inmobiliarias en España.
        </p>
        <p>
          La utilización del Sitio Web atribuye la condición de usuario e implica la aceptación plena de las
          condiciones incluidas en este aviso legal. Si no estás de acuerdo con ellas, abstente de utilizar el
          Sitio Web.
        </p>
      </LegalSection>

      <LegalSection title="3. Naturaleza informativa: no es asesoramiento financiero">
        <p>
          Los resultados, cálculos, puntuaciones (incluido el «PisoScore») y cualquier otra métrica mostrada en el
          Sitio Web tienen carácter meramente <strong className="font-semibold text-slate-900">orientativo e informativo</strong>.
          Se generan a partir de los datos introducidos por el usuario y de tipos impositivos generales publicados,
          sin tener en cuenta bonificaciones, reducciones ni circunstancias personales.
        </p>
        <p>
          Ningún contenido del Sitio Web constituye asesoramiento financiero, fiscal, jurídico o de inversión, ni
          una recomendación personalizada de compra o venta de activos. Antes de tomar cualquier decisión de
          inversión, consulta con un asesor financiero, fiscal o legal debidamente colegiado.
        </p>
      </LegalSection>

      <LegalSection title="4. Propiedad intelectual e industrial">
        <p>
          Todos los contenidos del Sitio Web (marca, logotipos, textos, diseño, código fuente, gráficos y
          algoritmos de cálculo) son titularidad de PisoScore Technologies S.L. o de sus licenciantes, y están
          protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción,
          distribución o explotación sin autorización expresa.
        </p>
      </LegalSection>

      <LegalSection title="5. Responsabilidad">
        <p>
          PisoScore no garantiza la exactitud, exhaustividad o vigencia de los tipos impositivos, cuotas hipotecarias
          estimadas ni demás datos utilizados en los cálculos, que pueden variar por cambios normativos o por las
          condiciones concretas de cada operación. El usuario es el único responsable de las decisiones que adopte
          con base en la información obtenida.
        </p>
        <p>
          PisoScore no será responsable de daños o pérdidas, directos o indirectos, derivados del uso del Sitio Web
          o de la imposibilidad de utilizarlo, incluidas pérdidas económicas derivadas de decisiones de inversión.
        </p>
      </LegalSection>

      <LegalSection title="6. Enlaces a terceros">
        <p>
          El Sitio Web puede contener enlaces a sitios de terceros. PisoScore no controla ni responde de los
          contenidos, políticas de privacidad o prácticas de dichos sitios.
        </p>
      </LegalSection>

      <LegalSection title="7. Legislación aplicable y jurisdicción">
        <p>
          Este aviso legal se rige por la legislación española. Para cualquier controversia derivada del acceso o
          uso del Sitio Web serán competentes los juzgados y tribunales que correspondan conforme a la normativa
          aplicable al consumidor y usuario.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
